import type { FaireProductEntity } from "../../entity_types/product";

export const p_wdcf7kv4an: FaireProductEntity = {
  token: "p_wdcf7kv4an",
  type: "product",
  name: "8oz Goat Milk Lotion",
  brandToken: "b_cw5lqh1hd4",
  brandName: "Simplified Soap",
  imageUrl:
    "https://cdn.faire.com/fastly/a5aa872b32ce4cf5d8314bcce299c4d46760040b3e56b5fac06cf9526fa1ed24.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8019524f187febcf92f00715f7676baf26a2a58b6fbe222c9082844c742963d4.jpeg",
    "https://cdn.faire.com/fastly/1ab83e1d3afe4deedd7a677b861ffc5cc87d9d11fdf30560d008a619218a2791.png",
    "https://cdn.faire.com/fastly/532b8fb4aa80976b06ecd52427452e7ff7c0c45cf72806c6ba7be3c9f9ec6276.png",
  ],
  priceDollars: 8.5,
  description:
    "This seriously luxurious lotion contains goat's milk, honey and natural shea butter. Goat's milk is high in proteins, triglycerides, vitamins A, B6, B12 and E. All this and more go into making this lotion an excellent moisturizer. Honey is a natural antioxidant and anti-inflammatory agent. Natural shea butter aids in healing and skin regeneration. Your skin will thank you! This lotion now comes in an 8oz glass apothecary bottle with clear labeling staying true to our vision of a simpler product.",
  tags: [],
  msrpDollars: 18.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:00.616Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
